export default __webpack_public_path__ + "static/media/screen_dropbox_5_3.700fe75d.png";